// Input handlers
import onInputHandler from './on-input';

// Elements
import Input from '../../input';
import Textarea from '../../textarea';

import { FormControl } from '../../model/form';
import { InputControl } from '../../model/input';
import { TextareaControl } from '../../model/textarea';

export default function processControls(controls: FormControl[]) {
  const getLitheFormElement = (control: FormControl) => {
    switch (control.element) {
      case 'input':
        return () =>
          Input({
            control: control as InputControl,
            onInput: (value: string) => onInputHandler(value, control),
          });
      case 'textarea':
        return () =>
          Textarea({
            control: control as TextareaControl,
            onInput: (value: string) => onInputHandler(value, control),
          });
      default:
        return undefined;
    }
  };

  return controls.map((control) => getLitheFormElement(control));
}
